/* eslint-disable import/prefer-default-export */
export function findNodeSiblingsWithIndex(nodesTree, nodeUuid) {
  const list = Array.isArray(nodesTree) ? nodesTree : [];
  const directIndex = list.findIndex((item) => item?.uuid === nodeUuid);

  if (directIndex > -1) {
    return {
      siblings: list,
      index: directIndex,
    };
  }

  let nestedResult = null;
  list.some((item) => {
    if (!Array.isArray(item?.items) || item?.items?.length === 0) {
      return false;
    }

    nestedResult = findNodeSiblingsWithIndex(item.items, nodeUuid);
    return !!nestedResult;
  });

  if (nestedResult) {
    return nestedResult;
  }

  return null;
}

export function findParentNode(nodesTree, nodeUuid) {
  const list = Array.isArray(nodesTree) ? nodesTree : [];

  const directParent = list.find((item) => Array.isArray(item?.items) && item?.items?.some((child) => child?.uuid === nodeUuid));
  if (directParent) {
    return directParent;
  }

  let nestedParent = null;
  list.some((item) => {
    nestedParent = findParentNode(item?.items, nodeUuid);
    return !!nestedParent;
  });

  return nestedParent;
}
